"use strict";
/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
function letProto(func) {
    return func(this);
}
exports.letProto = letProto;
//# sourceMappingURL=let.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/operator/let.js
 ** module id = 1466
 ** module chunks = 2
 **/